import React, { memo, useEffect } from 'react';
import { ExternalLink, Gift, Star, Sparkles } from 'lucide-react';

const Offers = () => {
  const offers = [
    {
      id: 1,
      name: 'Betclic',
      url: 'https://www.betclic.fr/',
      bonus: 'Bonus de bienvenue jusqu\'à 100€',
      icon: <Star className="w-8 h-8 text-yellow-400" />,
      description: 'Rejoignez l\'un des leaders du marché français et bénéficiez d\'un bonus de bienvenue généreux pour débuter vos paris en toute confiance.',
      color: 'from-blue-500 to-blue-700',
      textColor: 'text-blue-700',
      bgColor: 'bg-blue-50',
    },
    {
      id: 2,
      name: 'Olybet',
      url: 'https://olybet.fr/',
      bonus: 'Bonus de bienvenue de 100€',
      icon: <Sparkles className="w-8 h-8 text-purple-400" />,
      description: 'Une plateforme moderne avec une offre de bienvenue solide et des conditions de retrait avantageuses pour les nouveaux joueurs.',
      color: 'from-purple-500 to-purple-700',
      textColor: 'text-purple-700',
      bgColor: 'bg-purple-50',
    },
    {
      id: 3,
      name: 'Genybet',
      url: 'https://www.genybet.fr/',
      bonus: 'Bonus de bienvenue de 200€ + 50€ de paris gratuits',
      icon: <Gift className="w-8 h-8 text-green-400" />,
      description: 'L\'offre la plus généreuse du marché : 200€ de bonus plus 50€ de paris gratuits pour vous donner toutes les chances de gagner dès le départ.',
      color: 'from-green-500 to-green-700',
      textColor: 'text-green-700',
      bgColor: 'bg-green-50',
    },
  ];

  return (
    <section id="offres" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Les Meilleures Offres du Moment
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Sélectionnées pour leur générosité et leur fiabilité, ces offres vous permettent de commencer à parier avec un avantage significatif.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {offers.map((offer, index) => (
            <div
              key={offer.id}
              itemScope
              itemType="https://schema.org/Offer"
              className={`${offer.bgColor} rounded-2xl shadow-lg overflow-hidden transition-transform hover:scale-105 ${
                index === 2 ? 'lg:col-span-1 md:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className={`bg-gradient-to-r ${offer.color} p-6 text-white`}>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-2xl font-bold" itemProp="name">{offer.name}</h3>
                  {offer.icon}
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
                  <p className="font-semibold text-lg" itemProp="description">{offer.bonus}</p>
                </div>
              </div>
              
              <div className="p-6">
                <p className="text-gray-700 mb-6 leading-relaxed" itemProp="description">
                  {offer.description}
                </p>
                <a
                  href={offer.url}
                  itemProp="url"
                  target="_blank"
                  rel="noopener noreferrer nofollow sponsored"
                  className={`inline-flex items-center justify-center w-full px-6 py-3 ${offer.textColor} bg-white border-2 border-current rounded-lg font-semibold hover:bg-opacity-10 transition`}
                >
                  Jouer sur {offer.name}
                  <ExternalLink className="ml-2 w-5 h-5" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default memo(Offers);

